import { render, staticRenderFns } from "./NavItem.vue?vue&type=template&id=1206290c&scoped=true&"
import script from "./NavItem.vue?vue&type=script&setup=true&lang=ts&"
export * from "./NavItem.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./NavItem.vue?vue&type=style&index=0&id=1206290c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1206290c",
  null
  
)

export default component.exports